import DeviatingRegistrationsIndex from "./DeviatingRegistrationsIndex";

export default DeviatingRegistrationsIndex;
